import { inject, injectable } from "inversify";
import { DependencyType } from "@di/DependencyType";
import { ApolloClient, NormalizedCacheObject } from "@apollo/client";
import {
  CreateLabIndicatorDefinitionDocument,
  CreateLabIndicatorDefinitionInput,
  CreateLabIndicatorDefinitionMutation,
  CreateLabIndicatorDefinitionMutationVariables,
  CultivationsDocument,
  CultivationsQuery,
  CultivationsQueryVariables,
  LabIndicatorDefinitionQuery,
  LabIndicatorDefinitionsDocument,
  LabIndicatorDefinitionsQuery,
  LabIndicatorDefinitionsQueryVariables,
} from "generated/graphql";

@injectable()
export class LabIndicatorDefinitionService {
  constructor(
    @inject(DependencyType.ApolloClient)
    private readonly apolloClient: ApolloClient<NormalizedCacheObject>
  ) {}

  async findAll() {
    const queryTuple = await this.apolloClient.query<
      LabIndicatorDefinitionsQuery,
      LabIndicatorDefinitionsQueryVariables
    >({
      query: LabIndicatorDefinitionsDocument,
    });

    if (queryTuple.errors) {
      throw new Error(queryTuple.errors[0].message);
    }

    return queryTuple.data.labIndicatorDefinitions;
  }

  async create(input: CreateLabIndicatorDefinitionInput) {
    const mutationTuple = await this.apolloClient.mutate<
      CreateLabIndicatorDefinitionMutation,
      CreateLabIndicatorDefinitionMutationVariables
    >({
      mutation: CreateLabIndicatorDefinitionDocument,
      variables: {
        input,
      },
      refetchQueries: [
        {
          query: LabIndicatorDefinitionsDocument,
        },
      ],
      awaitRefetchQueries: true,
    });

    if (mutationTuple.errors) {
      throw new Error(mutationTuple.errors[0].message);
    }

    return mutationTuple.data?.createLabIndicatorDefinition;
  }
}
